<template>
  <ul class="Options">
    <li
      v-for="option in options"
      :key="option.id"
      @click="selectOption(option.id)"
      class="Options__Option"
    >
      {{ option.text }}
    </li>
  </ul>
</template>

<script>
import {
  FROM_ORIGIN,
  LAST_SEVEN_DAYS,
  LAST_THIRTY_DAYS,
  THIS_MONTH,
} from '@/constants';
export default {
  name: 'Options',
  data() {
    return {
      options: [
        {
          id: FROM_ORIGIN,
          text: this.$t(`date-picker.${FROM_ORIGIN}`),
        },
        {
          id: LAST_SEVEN_DAYS,
          text: this.$t(`date-picker.${LAST_SEVEN_DAYS}`),
        },
        {
          id: LAST_THIRTY_DAYS,
          text: this.$t(`date-picker.${LAST_THIRTY_DAYS}`),
        },
        {
          id: THIS_MONTH,
          text: this.$t(`date-picker.${THIS_MONTH}`),
        },
      ],
    };
  },
  methods: {
    selectOption(id) {
      this.$emit('onOptionClick', id);
    },
  },
  props: {
    firstAvailableDate: {
      type: [Date, String],
      required: false,
    },
    selected: {
      type: String,
      required: false,
    },
  },
};
</script>

<style lang="scss">
.Options {
  list-style: none;
  padding-left: 0;
  width: rem(120px);

  &__Option {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-size: rem(11px);
    height: rem(40px);

    &:not(:last-child) {
      border-bottom: rem(1px) solid $white-700;
    }

    &--selected {
      &::before {
        background: $blue-300;
        content: '';
        height: rem(20px);
        margin-right: rem(10px);
        width: rem(2px);
      }
    }
    &--disabled {
      pointer-events: none;
    }
  }
}
</style>
